/**
 * @flow
 * @relayHash 06fcb7a27a7433d30b6101d28d244639
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ContactMediumUpdateInput = {|
  id: string,
  name: string,
|};
export type UpdateContactMediumMutationVariables = {|
  data: ContactMediumUpdateInput
|};
export type UpdateContactMediumMutationResponse = {|
  +updateContactMedium: {|
    +id: string
  |}
|};
export type UpdateContactMediumMutation = {|
  variables: UpdateContactMediumMutationVariables,
  response: UpdateContactMediumMutationResponse,
|};
*/


/*
mutation UpdateContactMediumMutation(
  $data: ContactMediumUpdateInput!
) {
  updateContactMedium(data: $data) {
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "data",
    "type": "ContactMediumUpdateInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "updateContactMedium",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "data",
        "variableName": "data"
      }
    ],
    "concreteType": "ContactMediumModel",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "UpdateContactMediumMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "UpdateContactMediumMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "UpdateContactMediumMutation",
    "id": null,
    "text": "mutation UpdateContactMediumMutation(\n  $data: ContactMediumUpdateInput!\n) {\n  updateContactMedium(data: $data) {\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '45745e124ac7bf2abb1773b34466d674';
module.exports = node;
